/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef } from 'react';
import {
  Button,
  chakra,
  Divider,
  Box,
  Text,
  Icon as ChakraIcon,
  Avatar,
  Heading,
  Link,
  LinkBox,
  LinkOverlay,
  Flex,
  IconButton,
  Tag,
  useDisclosure,
  FormControl,
  InputRightElement,
} from '@chakra-ui/react';
import { BiArrowBack, BiListCheck } from 'react-icons/bi';
import { Icon } from 'rsuite';
import styled from 'styled-components';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { FaPlusCircle } from 'react-icons/fa';
import { RiListCheck } from 'react-icons/ri';
import { BsChatDotsFill, BsPeopleFill } from 'react-icons/bs';
import * as Constants from '../../../constants';
import { Episode, EpisodeSection, User } from '../../../@types';
import { useEpisodeStore } from '../../../store';
import { EpisodePartsNav } from './EpisodePartsNav';
import { useRole } from '../../../hooks';
import { maybeEnrollEpisode, useSonarGroups } from '../../../api';
import BlgButton from '../../../components/Button/Button';
import { BlgModalSonarPlus } from '../../../components/ModalSonar/ModalSonarPlus';
import { EpisodeChat } from './EpisodeChat';
import { BlgModalEpisode } from '../../../components/ModalEpisode/ModalEpisode';

const DashboardWrapper = styled.div`
  position: absolute;
  z-index: 200;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  right: 0;
  background: linear-gradient(45deg, #003, #000);
  // background: linear-gradient(-45deg, #000000cc, #07062f, #2294ef, #361d73);
  font-family: var(--font-family-alt);
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease-in-out, opacity 0.4s, visibility 0s;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-1000px);
  .overlay-img {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    object-fit: cover;
    opacity: 0.5;
    width: 100%;
  }
  .end-screen-inner {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    opacity: 0;
    transition: opacity 0.4s, transform 0.3s;
    transition-delay: 0.7s;
    transform: translateY(100px);
    header {
      padding: 40px;
    }
    main .box-wrapper {
      opacity: 0;
      transition: opacity 0.4s, transform 0.3s;
      transform: translateY(100px) scale(0.5);
    }

    &.is-visible {
      opacity: 1;
      visibility: visible;
      transform: translateY(0) scale(1);
      header,
      main .box-wrapper {
        opacity: 1;
        transform: translateY(0);
      }
    }
    &.is-faded {
      transition: opacity 1.5s ease-out;
      pointer-events: none;
      opacity: 0 !important;
    }
  }
  &.show {
    transform: translateY(0);
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  header,
  main {
    flex-basis: 100%;
  }
  header {
    padding: 40px 0;
    color: #fff;
    flex: 0;
    h2 {
      text-align: center;
      font-family: 'Londrina Solid', sans-serif;
      font-size: 3rem;
      letter-spacing: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 2px dashed;
      padding-bottom: 30px;

      i {
        font-size: 50px;
        margin-right: 20px;
        background: #18bd18;
        border-radius: 50%;
      }
    }
    p {
      font-size: 1.1rem;
      padding: 20px 0 0;
      text-align: center;
      font-weight: 300;
      line-height: 1.7;
    }
  }
  main {
    /* flex-grow: 1; */
    width: 85%;
    margin: 0 auto;
    height: calc(100% - 250px);
    flex-basis: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .box-wrapper {
      width: calc(50% - 25px);
      height: calc(50% - 25px);
      flex-grow: 1;
      margin: 12px;
    }
    section {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      position: relative;
      cursor: pointer;
      transform: scale(1);
      transition: transform 0.2s, opacity 0.4s, box-shadow 0.2s;
      opacity: 0.8;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      z-index: 6;
      box-shadow: 1px 1px 30px #00000024;
      border-radius: 12px;
      overflow: hidden;

      h3 {
        color: #fff;
        position: relative;
        z-index: 6;
        top: 50%;
        transform: translateY(-50%);
        font-weight: 200;
        font-size: 2rem;
        padding: 12px 40px;
        border-radius: 50px;
        border: 2px solid #fff0;
        transition: 0.2s;
        background: rgba(0, 0, 0, 0);
        letter-spacing: -0.5px;
      }

      .box-overlay {
        position: absolute;
        left: 0;
        right: 0;

        background-image: linear-gradient(to top, black, rgba(0, 0, 0, 0.5));
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
        bottom: 0;
        top: 0;
        pointer-events: none;
        transition: all 0.25s ease;
        z-index: 5;
      }
      &:hover {
        z-index: 8;
        box-shadow: 1px 1px 30px #000;
        opacity: 1;

        h3 {
          top: 95%;
          transform: translateY(-100%);
        }

        .box-overlay {
          top: calc(100% - 100px);
        }
      }
    }
  }
`;
const CloseButton = styled.div`
  /* position: absolute; */
  /* margin: 20px; */
  /* right: 0; */
  /* top: 0; */
  /* z-index: 300; */
  /* cursor: pointer; */
  color: #fff;
  display: flex;
  align-items: center;
`;
export const EpisodeDashboard: React.FC<{
  episode: Episode;
  currentUser: User | undefined;
  sectionState?: [
    EpisodeSection[],
    EpisodeSection,
    (sectionIdx: number) => void
  ];
  setShowDashboard: (show: boolean) => void;
  show: boolean;
}> = ({ setShowDashboard, sectionState, currentUser, episode, show }) => {
  const isIframe = window.location !== window.parent.location;
  const [sections, currentSection, setCurrentSection] = sectionState || [];
  const currentSectionIdx = sections
    ? sections.findIndex(({ id }) => id === currentSection?.id)
    : -1;
  const [isVisible, setIsVisible] = React.useState(false);
  const [isFaded, setIsFaded] = React.useState(false);
  const { EPISODE_ACTIONS, progress, player } = useEpisodeStore.getState();
  const { userRole } = useRole();
  const { isStudent = false } = userRole || {};
  const {
    data: { active: groups, pending } = {},
    isLoading: sonarLoading,
  } = useSonarGroups(episode.id, currentUser?.id || '');

  const numAlerts =
    (pending?.length || 0) +
    (groups || []).reduce(
      (sum: number, g: Record<string, any>) => sum + g.unread_count,
      0
    );

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setIsVisible(true);
      }, 200);
    }
  }, [show]);

  const handleStart = () => {
    if (currentUser && isStudent) {
      maybeEnrollEpisode(currentUser.id, episode.id);
    }
    if (player?.paused()) {
      setIsFaded(true);
      setTimeout(() => {
        EPISODE_ACTIONS.playVideo();
        setShowDashboard(false);
        setIsFaded(false);
      }, 2000);
    }
  };

  const Image = chakra.img;
  const {
    isOpen: isOpenSonar,
    onOpen: onOpenSonar,
    onClose: onCloseSonar,
  } = useDisclosure();
  const {
    isOpen: isOpenChat,
    onOpen: onOpenChat,
    onClose: onCloseChat,
  } = useDisclosure();

  const {
    isOpen: isOpenInfos,
    onOpen: onOpenInfos,
    onClose: onCloseInfos,
  } = useDisclosure();

  return (
    <DashboardWrapper className={`${show ? 'show' : ''}`}>
      <Image
        className="overlay-img"
        backgroundSize="cover"
        backgroundImage={episode.cover_image}
      />
      <Flex mt={1} px={6} py={4} position="relative" justify="space-between">
        <Flex justify="space-between" gap={2}>
          {!isIframe && (
            <BlgButton
              as="a"
              href={`${Constants.ROOT_URL}/explore`}
              colorScheme="gray"
              color="black"
              leftIcon={<FiArrowLeft />}
            >
              Library
            </BlgButton>
          )}

          <BlgButton
            variant="solid"
            colorScheme="ligthBlue"
            color="black"
            leftIcon={<FiArrowLeft />}
            fontWeight={700}
            as="a"
            target={isIframe ? '_top' : '_self'}
            href={`${Constants.ROOT_URL}/series/${episode.series.slug}`}
          >
            Series
          </BlgButton>
          <Flex>
            {currentUser && currentUser.user_role_id === 2 && (
              <>
                {currentUser.access_level === 2 && (
                  <IconButton
                    aria-label="ListCheck"
                    icon={<RiListCheck />}
                    fontSize={20}
                    borderRadius="full"
                    bg="transparent"
                    colorScheme="whiteAlpha"
                    onClick={onOpenInfos}
                  />
                )}
                <IconButton
                  aria-label="ListCheck"
                  icon={<FaPlusCircle />}
                  fontSize={20}
                  borderRadius="full"
                  bg="transparent"
                  colorScheme="whiteAlpha"
                  onClick={onOpenSonar}
                />
              </>
            )}
            <Flex
              borderRadius="full"
              w={10}
              h={10}
              justifyContent="center"
              position="relative"
            >
              {numAlerts > 0 && (
                <Flex
                  position="absolute"
                  top={1}
                  right={-0.5}
                  w={4}
                  h={4}
                  zIndex={2}
                  bg="red.500"
                  borderRadius="full"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Text fontSize={10} color="white" fontWeight={700}>
                    {numAlerts}
                  </Text>
                </Flex>
              )}
              <IconButton
                aria-label="ListCheck"
                icon={<BsChatDotsFill />}
                fontSize={20}
                borderRadius="full"
                bg="transparent"
                colorScheme="whiteAlpha"
                onClick={onOpenChat}
              />
            </Flex>
          </Flex>
        </Flex>
        <Flex alignItems="center" gap={4} mr={8}>
          {!isIframe && currentUser && (
            <>
              <Avatar h={10} w={10} src={currentUser?.avatar} />
              <Text fontSize={14} fontWeight={600} color="white">
                {currentUser?.username}
              </Text>
              <BlgButton
                leftIcon={<FiArrowRight />}
                variant="solid"
                colorScheme="newGreen"
                fontWeight={700}
                as="a"
                href={`${Constants.ROOT_URL}/users/logout`}
              >
                Log out
              </BlgButton>
            </>
          )}
          <IconButton
            aria-label="Close"
            bg="transparent"
            onClick={() => setShowDashboard(false)}
            color="white"
            borderRadius="full"
          >
            <Icon size="lg" icon="close" />
          </IconButton>
        </Flex>
      </Flex>
      <div
        className={`end-screen-inner ${isVisible ? 'is-visible' : ''} ${
          isFaded ? 'is-faded' : ''
        }`}
      >
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="end"
          gap={8}
          pb={{ base: 10, lg: 32 }}
        >
          <Flex
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
            color="white"
          >
            <Tag
              bg="white"
              fontWeight={700}
              fontSize={16}
              px={9}
              py={3}
              borderRadius="full"
            >
              {episode?.series?.overflow_title || 'Belouga'}
            </Tag>
            <Text
              fontSize={54}
              fontWeight={800}
              textAlign="center"
              textShadow="1px 1px black"
            >
              {episode.title}
            </Text>
            <Text
              fontSize={18}
              fontWeight={400}
              textAlign="center"
              textShadow="1px 1px black"
              maxW={800}
              fontFamily="sans-serif"
              fontStyle="italic"
            >
              {episode.description}
            </Text>
          </Flex>

          <Flex
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            {!!sections?.length && currentSectionIdx >= 0 && (
              <EpisodePartsNav
                sections={sections}
                currentSectionIdx={currentSectionIdx}
              />
            )}
          </Flex>

          <BlgButton
            variant="solid"
            colorScheme="newGreen"
            onClick={handleStart}
            leftIcon={<FiArrowRight />}
            fontWeight={600}
            px={10}
            fontSize={18}
          >
            Start learning
          </BlgButton>
          <Flex alignItems="end" gap={2}>
            <Text fontSize={14} pb={1} color="white">
              Presented by
            </Text>
            <Image
              h="64px"
              src={episode.creator.logo_url}
              alt="BelougaLogoSky"
              objectFit="contain"
            />
          </Flex>
        </Flex>
      </div>
      {isOpenInfos && (
        <BlgModalEpisode
          episode={episode}
          isOpen={isOpenInfos}
          onClose={onCloseInfos}
        />
      )}
      {isOpenChat && currentUser && (
        <EpisodeChat
          isOpen={isOpenChat}
          isLoading={sonarLoading}
          sonarGroups={[groups, pending]}
          user={currentUser}
          episodeId={episode.id}
          onClose={onCloseChat}
        />
      )}
      {isOpenSonar && (
        <BlgModalSonarPlus
          isOpen={isOpenSonar}
          onClose={onCloseSonar}
          episode={episode}
        />
      )}
    </DashboardWrapper>
  );
};
